var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "red",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.898 13.5c-4.595 0-8.91.328-11.208.787-1.531.328-2.855 1.312-3.133 2.822C9.28 18.683 9 21.047 9 24s.277 5.25.625 6.89c.28 1.444 1.602 2.495 3.133 2.823 2.439.459 6.613.787 11.208.787s8.77-.328 11.205-.787c1.534-.328 2.856-1.312 3.133-2.822.28-1.641.628-4.002.696-6.955 0-2.953-.348-5.317-.696-6.957-.277-1.444-1.599-2.495-3.133-2.823-2.436-.328-6.68-.656-11.273-.656zm0 1.313c5.011 0 9.047.392 10.996.72 1.044.264 1.879.92 2.018 1.774.418 2.1.696 4.332.696 6.629-.068 2.82-.416 5.117-.696 6.757-.207 1.246-1.6 1.64-2.018 1.774-2.507.459-6.683.785-10.86.785s-8.421-.262-10.857-.785c-1.045-.264-1.88-.92-2.018-1.774-.557-1.838-.767-4.265-.767-6.693 0-3.02.28-5.25.558-6.627.209-1.248 1.67-1.643 2.017-1.774 2.298-.458 6.545-.787 10.931-.787zm-3.76 3.937v10.5L29.882 24l-9.746-5.25zm1.392 2.233L27.098 24l-5.568 3.017v-6.034z",
    transform: "translate(8 8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficYoutube);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-youtube.e833ace9.svg";
export { ForwardRef as ReactComponent };